import { Close } from "@mui/icons-material";
import {
  Box,
  CircularProgress,
  Divider,
  LinearProgress,
  Paper,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import Button from "../base/Button";
import theme from "../../theme";
import moment from "moment";

interface Props {
  onClose: () => void;
}

const ConnectionSetup: React.FC<Props> = (props) => {
  const { onClose } = props;
  const [progress, setProgress] = useState<number>(0);
  const connectionId = "CONN-29875";

  useEffect(() => {
    const timer = setInterval(() => {
      setProgress((oldProgress) => {
        if (oldProgress === 100) {
          return 0;
        }
        const diff = Math.random() * 10;
        return Math.min(oldProgress + diff, 100);
      });
    }, 500);

    return () => {
      clearInterval(timer);
    };
  }, []);

  return (
    <Paper sx={{ width: { lg: 600, md: 450, xs: window.innerWidth } }}>
      <Box
        display={"flex"}
        flexDirection={"column"}
        sx={{ paddingX: 2, paddingTop: 2 }}
      >
        <Box
          display={"flex"}
          flexDirection={"row"}
          justifyContent={"space-between"}
          alignItems={"center"}
          marginBottom={2}
        >
          <Typography variant="h4" fontWeight={"bold"}>
            Connection Setup
          </Typography>
          <Button
            variant={"contained"}
            color={"inherit"}
            onClick={onClose}
            icon={<Close />}
          />
        </Box>
        <Divider />
        <Box
          display={"flex"}
          flexDirection={"column"}
          justifyContent={"center"}
          alignItems={"center"}
          p={2}
          gap={2}
        >
          <CircularProgress
            sx={{ color: theme.palette.primary.main }}
            size={60}
          />
          <Typography variant="h4">Congifuring New Connection</Typography>
          <Typography variant="caption">
            This process will take approximately 1-2 minutes to complete.
          </Typography>
          <Box sx={{ width: "100%", py: 3 }}>
            <LinearProgress
              value={progress}
              color="primary"
              variant="determinate"
              style={{
                height: 10,
                backgroundColor: theme.palette.background.default,
                borderRadius: 8,
              }}
            />
          </Box>
          <Typography variant="subtitle1">
            You can dismiss this popup and the connection will continue to be
            configured in the background.
          </Typography>
          <Box alignSelf={"flex-end"}>
            <Button onClick={onClose} variant="contained" label="Dismiss" />
          </Box>
        </Box>
      </Box>
      <Divider />
      <Box
        display={"flex"}
        flexDirection={"row"}
        justifyContent={"space-between"}
        padding={2}
        sx={{
          backgroundColor: theme.palette.background.default,
          borderBottomLeftRadius: "5px",
          borderBottomRightRadius: "5px",
        }}
      >
        <Typography variant="subtitle1">
          Connection ID: {connectionId}
        </Typography>
        <Typography variant="subtitle1">
          Started at {moment(new Date()).format("hh:mm A")}
        </Typography>
      </Box>
    </Paper>
  );
};

export default ConnectionSetup;
